import './videoOverlay.scss';
import * as React from 'react';
import { icons } from '../../content/icons';
import { AnalyticsService } from '../../utils/analytics';
import { RMButton } from '../layout/rmButton';
import { Portal } from '../portal';
import { VimeoPlayer } from '../socialMedia/vimeoPlayer';
export const VideoOverlay = ({ isOpen, onClose, vimeoId }) => {
    React.useEffect(() => {
        if (isOpen) {
            AnalyticsService.track('videoClicked', { vimeoId });
        }
    }, [isOpen]);
    return (isOpen && (<Portal>
        <div className="video-overlay-wrapper">
          <div className="close-video-overlay" onClick={onClose}/>
          <div className="video-overlay">
            <RMButton className="close-video-overlay-button icon-button" onClick={onClose} leftIcon={icons.cancel} variant="lighten-bg"/>

            <VimeoPlayer id={vimeoId}/>
          </div>
        </div>
      </Portal>));
};
